export default {"src":"/polygon/_next/static/media/harvest.87194160.svg","height":50,"width":50};